import validator from 'validator';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { isRequiredWithObj, strMax } from '../../utils';
export default {
    linkUrl: [
        strMax(255, 'URLは255文字以内で入力してください'),
        isRequiredWithObj('タイトルを入力する場合、URLも入力してください', 'title'),
        (value) => {
            if (isNullOrUndefinedOrEmpty(value) || validator.isURL(value)) {
                return '';
            }
            return 'URLを入力してください';
        },
    ],
    title: [
        strMax(255, 'タイトルは255文字以内で入力してください'),
        isRequiredWithObj('URLを入力する場合、タイトルも入力してください', 'linkurl'),
    ],
};
